import { render } from "./AddProductCategory.vue?vue&type=template&id=9c056d26"
import script from "./AddProductCategory.vue?vue&type=script&lang=js"
export * from "./AddProductCategory.vue?vue&type=script&lang=js"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__